import moduleInfo from '../module.json';
import type { AppRuntime } from '@ayocore/platform/client/runtime/AppRuntime';
import { IconBell } from '@tabler/icons-react';
// no-op
import NotificationsMenuBadge from './components/elements/NotificationsMenuBadge';
import { NotificationsDockPanel } from './components/NotificationsDockPanel';
import { lazy } from 'react';

/**
 * Бутстрап модуля уведомлений (клиент)
 * Регистрирует навигацию через рантайм.
 */
export async function setup(app: AppRuntime) {
  const notifications = app.useModule(moduleInfo.name, {
    version: moduleInfo.version,
    description: moduleInfo.description,
  });

  notifications.useNavigation({
    icon: IconBell,
    label: 'Уведомления',
    url: '/notifications',
    component: lazy(() => import('./components/NotificationsList')),
    badge: NotificationsMenuBadge,
  });

  notifications.useDock({
    id: 'notifications-dock',
    label: 'Уведомления',
    icon: IconBell,
    component: NotificationsDockPanel,
    badge: NotificationsMenuBadge,
    order: 10,
  });
}
